import React, { useState, useEffect } from 'react';

export default function DebugModal({ isOpen, onClose, cardParams, setCardParams }) {
  const [jsonText, setJsonText] = useState('');
  const [error, setError] = useState(null);

  // Sync modal text state when modal opens or cardParams changes externally
  useEffect(() => {
    if (isOpen) {
      setJsonText(JSON.stringify(cardParams, null, 2));
      setError(null);
    }
  }, [isOpen, cardParams]);

  if (!isOpen) return null;

  const handleApply = () => {
    try {
      const parsed = JSON.parse(jsonText);
      setCardParams(parsed);
      setError(null);
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-dark text-light border-secondary">
          <div className="modal-header border-secondary">
            <h5 className="modal-title">Debug State Editor</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <p className="text-muted small">
              Edit the raw card parameters below. Click "Apply Changes" to update the application state.
            </p>
            
            {error && (
              <div className="alert alert-danger py-2 small" role="alert">
                <strong>Invalid JSON:</strong> {error}
              </div>
            )}

            <textarea
              className="form-control bg-black text-warning font-monospace small"
              rows="15"
              value={jsonText}
              onChange={(e) => setJsonText(e.target.value)}
              style={{ resize: 'vertical' }}
            />
          </div>
          <div className="modal-footer border-secondary">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-warning" onClick={handleApply}>
              Apply Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}